import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS } from 'utils/styles/fonts';

export const StyledButton = styled(NavLink)`
  color:${COLORS.white};
  background: ${COLORS.mainColor};
  border: 1px solid ${COLORS.mainColor};
  border-radius: 8px;
  padding: 8px 0;
  text-align: center;
  width: 124px;
  opacity: 1;

  &:hover {
    opacity: 0.85;
  }
`;

export const StyledLogOutImage = styled.img``;

export const StyledFlexContainer = styled.div`
    ${FLEX_CONTAINER.FlexRow}
    grid-gap: 10px;
    cursor:pointer;
`;

export const StyledLogOutText = styled.div`
    color: ${COLORS.mainColor};
    ${FONTS.font16}
  
`;
